import React from 'react'

const usePaginationWithData = (data, params = {}) => {
  const [paginatedData, setPaginatedData] = React.useState([])
  const [page, setPage] = React.useState(params.page || 1)
  const [perPage, setPerPage] = React.useState(params.perPage || 20)

  React.useEffect(() => {
    const endIndex = page * perPage
    const startIndex = endIndex - perPage

    setPaginatedData(data.slice(startIndex, endIndex))
  }, [data, page, perPage])

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1)
  }

  const handleChangeRowsPerPage = event => {
    setPerPage(parseInt(event.target.value, 10))
  }

  return {
    handleChangeRowsPerPage,
    handleChangePage,
    page,
    perPage,
    data: paginatedData,
  }
}

export default usePaginationWithData
